module.exports = __webpack_public_path__ + "img/hzjg1.3978fd49.png";